import React from "react";
import { Box } from "@mui/material";
import AuditLogPage from "../../components/AuditLog";

function AuditPage() {
  return (
    <Box height="100%" width="100%">
      <AuditLogPage />
    </Box>
  );
}

export default AuditPage;
